export default __webpack_public_path__ + "static/media/hht2_ep_01.9be90dc3.png";